import { Component, OnInit } from "@angular/core";
import { PATHS, ROUTES } from "src/constants";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent implements OnInit {
  public year: number;
  public ROUTES = ROUTES;
  public PATHS = PATHS;
  constructor() {}

  ngOnInit() {
    this.year = new Date().getFullYear();
  }
}
